import type { $ } from "../../../dom";
import { Input, type InputOptions } from "../../core";

export type ButtonInputOptions<TValue> = InputOptions<TValue> & {};

export abstract class ButtonInput<TValue, TData = TValue> extends Input<
  TValue,
  TData
> {
  constructor($root: $, options: ButtonInputOptions<TValue>) {
    const { ...superOptions } = options;

    super($root, superOptions);

    this.$root.attr("role", "button");
    this.$root.attr("tabIndex", 0);

    this.$root.on("click:relkit-input", () => {
      this.toggle();
    });
    this.$root.on("keydown:relkit-input", (event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();

        this.toggle();
      }
    });
  }

  toggle() {
    this.isActive = !this.isActive;
  }

  get isActive(): boolean {
    return this.$root.flag("active");
  }

  set isActive(value: boolean) {
    this.$root.flag("active", value);

    this.triggerInput();
    this.triggerChange();
  }
}
